import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Layout from '~/src/layout/_layout';
import * as base from '~/src/helpers/basePageFunc';
import { DomruInternet } from '~/src/layout/domru-internet';

const DomruInternetPage = (props) => {
    const { hostname } = props;
    const currentCity = useSelector(state => state.city.currentCity);
    const link = `https://${currentCity?.domain}.dom.ru/domru-internet`;

    return (
        <Layout
            title={`Подключить домашний интернет от Дом.ру в ${currentCity?.cityIn} | Провести быстрый интернет для дома через оптоволокно`}
            description={`Провайдер Дом.ру в Перми предлагает подключить скоростной интернет в квартиру по выгодной стоимости. Тарифы и цены на сайте. Оставьте заявку на подключение: ☎ ${currentCity?.phone}`}
            hostname={hostname}
            withMenu={true}
            withChat={true}
            withFooter={true}
            relCanonical={link}
        >
            <DomruInternet />
        </Layout>
    );
};

DomruInternetPage.getInitialProps = async(ctx) => {
    const { hostname } = await base.initialProps(ctx);
    return { hostname };
};

DomruInternetPage.propTypes = {
    currentCity: PropTypes.object,
    hostname: PropTypes.string,
};

DomruInternetPage.defaultProps = {
    currentCity: {},
    hostname: '',
};

export default DomruInternetPage;
